export default __webpack_public_path__ + "images/pattern-3.e0f83f305e2cec2471c56c3a89792beb.svg";